<template>

    <div id="agility_tab" class="flex_content" v-if="currentEval.saven_test">

        <div class="container">

            <div class="strength_scores">

                <StrengthScore :dimId="currentEval.saven_test.strengths_order[0][0]" :scoreIndex="1" />
                <StrengthScore :dimId="currentEval.saven_test.strengths_order[1][0]" :scoreIndex="2" />
                <StrengthScore :dimId="currentEval.saven_test.strengths_order[2][0]" :scoreIndex="3" />
                <StrengthScore :dimId="currentEval.saven_test.strengths_order[3][0]" :scoreIndex="4" />
                <StrengthScore :dimId="currentEval.saven_test.strengths_order[4][0]" :scoreIndex="5" />

            </div>

        </div>
    </div>

</template>

<script>
import StrengthScore from '../scores/strengthScore'

export default {
    name: 'StrengthTab',
    components: {
        StrengthScore
    },
    beforeCreate() {

    },
    data(){
        return {}
    },
    computed: {
        currentEval(){
            return this.$store.state.EvalStore.currentEval
        }
    },
    methods: {

    }
}
</script>

<style lang="scss" scoped>
.strength_scores{
    margin-top: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
</style>